export const PAYMENT_METHOD = {
  creditCard: 'credit_card',
  applePay: 'apple_pay',
  googlePay: 'google_pay',
};
